var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingCheck)?_c('div',[_c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{attrs:{"size":50,"color":"white","indeterminate":""}}),_c('h4',[_vm._v(_vm._s(_vm.loadingMessage))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }